import styled from 'styled-components';

import { Carousel as BreweryCarousel } from '@xing-com/carousel';

export const Carousel = styled(BreweryCarousel)`
  &::-webkit-scrollbar {
    display: none;
  }

  max-width: 100vw;
  scrollbar-width: none;
`;
